import { Modal } from "antd";
import React from "react";

const ModalComp = ({
  isModalOpen,
  handleCancel,
  handleOk,
  content,
  height,
}) => {
  return (
    <Modal
      style={{ whiteSpace: "pre-wrap", fontSize: "16px", lineHeight: "1.8" }}
      bodyStyle={{
        maxHeight: height ? height : "60vh",
        overflowY: "auto",
        whiteSpace: "pre-wrap",
        fontSize: "16px",
        lineHeight: "1.8",
      }}
      title="Privacy Policy"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="I Agree"
      cancelText="Cancel"
    >
      <p>{content}</p>
    </Modal>
  );
};

export default ModalComp;
